import React, { useState } from 'react';
import { siteCopy } from '../../content/siteCopy';
import { appShowcaseTabs } from '../../constants/appShowcaseTabs';

const LookInside = () => {
  const { lookInside } = siteCopy;
  const [activeId, setActiveId] = useState(appShowcaseTabs[0].id);
  const activeTab =
    appShowcaseTabs.find((tab) => tab.id === activeId) ?? appShowcaseTabs[0];

  return (
    <section className="row_am look_inside_section" id="look_inside_sec">
      <div className="container">
        <div
          className="section_title"
          data-aos="fade-up"
          data-aos-duration={1500}
        >
          <span className="title_badge">{lookInside.badge}</span>
          <h2>{lookInside.title}</h2>
          <p>{lookInside.intro}</p>
        </div>
        <div className="look_inside_panel" data-aos="fade-up" data-aos-duration={1500}>
          <div className="look_inside_mobile_nav">
            <label className="look_inside_mobile_label" htmlFor="look-inside-select">
              Browse screens
            </label>
            <select
              id="look-inside-select"
              className="look_inside_select"
              value={activeId}
              onChange={(event) => setActiveId(event.target.value)}
            >
              {appShowcaseTabs.map((tab) => (
                <option key={tab.id} value={tab.id}>{tab.title}</option>
              ))}
            </select>
          </div>
          <div
            className="look_inside_tabs look_inside_tabs--desktop"
            role="tablist"
            aria-label="App screenshots"
          >
            {appShowcaseTabs.map((tab) => {
              const isActive = tab.id === activeId;
              return (
                <button
                  key={tab.id}
                  type="button"
                  role="tab"
                  id={`look-inside-tab-${tab.id}`}
                  aria-selected={isActive}
                  aria-controls={`look-inside-panel-${tab.id}`}
                  className={`look_inside_tab${isActive ? ' is-active' : ''}`}
                  onClick={() => setActiveId(tab.id)}
                >
                  <span className="look_inside_tab_title">{tab.title}</span>
                  <span className="look_inside_tab_body">{tab.body}</span>
                </button>
              );
            })}
          </div>
          <div
            className="look_inside_preview"
            role="tabpanel"
            id={`look-inside-panel-${activeTab.id}`}
            aria-labelledby={`look-inside-tab-${activeTab.id}`}
          >
            <div className="look_inside_phone">
              <img src={activeTab.image} alt={activeTab.alt} />
            </div>
            <div className="look_inside_caption">
              <h3>{activeTab.title}</h3>
              <p>{activeTab.body}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LookInside;
